export const cachePolicies = {
  typePolicies: {
    EpicIntegrationRecordSettingsType: {
      keyFields: ["providerContextToken", "patientContextToken"],
    },
  },
};
